module.exports = __webpack_public_path__ + "img/39_71.b3fb857e.png";